define('casino/game-resize',['jquery', 'all/player/session', 'casino/casino', 'casino/info', 'casino/detect-zoom', 'casino/game-mode', 'casino/instantdeposit', 'casino/activity-feed', 'casino/ingameFunctionalities'], function ($, session, casino, casinoInfo, detectZoom, gameMode, instantDeposit, activityFeed, ingameFunctionalities) {
        'use strict';

        var HARDCODED_GAME_MARGIN_PIXELS = 10;
        var BOTH_SIDE_MARGINS_WIDTH = 2 * HARDCODED_GAME_MARGIN_PIXELS;

        var RESIZE_DELAY = 200;

        var DEFAULT_SIZE_BUTTON = 's24-normal';
        var EXPANDED_SIZE_BUTTON = 's24-expanded';
        var MAXIMIZED_SIZE_BUTTON = 's24-maximized';

        var DEFAULT_MAX_WIDTH = 800;
        var DEFAULT_MAX_HEIGHT = 600;

        // $('#casino-ingame').find('.game-holder').outerHeight() - $ingame.find('.game-holder .content').outerHeight();
        var GAME_MARGIN_HEIGHT = 70;

        // $('#casino-ingame').find('.player-bar').outerHeight()
        //var PLAYER_BAR_HEIGHT = 50;

        // $('#casino-ingame').find('.content-wrapper').outerHeight()
        var TOP_BAR_HEIGHT = 70;

        var GROUP_ASPECT_RATIO = 4 / 3;

        var $window = $(window);
        var resizeTimeout;

        var gameResize = {};

        gameResize.resize = resize;
        gameResize.scrollIntoView = scrollIntoView;
        gameResize.setSelectedGameSizeButton = setSelectedGameSizeButton;

        gameResize.init = function onload() {
            setupGameSizeButtons();
            setSelectedGameSizeButton();
        };

        function setupGameSizeButtons() {
            if (casinoInfo.isSmallScreen()) {
                removeMiddleButton();
            }

            $('#casino-ingame').find('#size-mode').find('.toggle a').on('click', gameSizeHandler);
        }

        function removeMiddleButton() {
            $('#casino-ingame').find('#size-mode').find('.toggle a span.' + EXPANDED_SIZE_BUTTON).parent().remove();
        }

        function gameSizeHandler() {
            var $a = $(this);

            if ($a.hasClass('active')) {
                return;
            }

            $a.siblings().removeClass('active');
            $a.addClass('active');

            if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
                saveGameSizeInLocalStorage($a);
            }

            resize();
            scrollIntoView();

        }

        function setSelectedGameSizeButton() {

            var selectedSize;

            if (casinoInfo.isSmallScreen()) {
                selectedSize = DEFAULT_SIZE_BUTTON;
            } else if (gameMode.getGameMode() !== gameMode.MODE_ONE_GAME) {
                selectedSize = MAXIMIZED_SIZE_BUTTON;
            } else if (localStorage && localStorage.gameSize) {
                selectedSize = localStorage.gameSize;
            } else {
                selectedSize = DEFAULT_SIZE_BUTTON;
            }

            var $selected = $('#casino-ingame').find('#size-mode').find('.toggle a .' + selectedSize).parent();
            $selected.siblings().removeClass('active');
            $selected.addClass('active');

            showHideSizeBasedOnGameMode();
        }

        function showHideSizeBasedOnGameMode() {
            var $sizeMode = $('#casino-ingame').find('#size-mode');
            if (gameMode.getGameMode() !== gameMode.MODE_ONE_GAME) {
                $sizeMode.hide();
                $sizeMode.prev().hide();
                $sizeMode.next().hide();
            } else {
                $sizeMode.show();
                $sizeMode.prev().show();
                $sizeMode.next().show();
            }
        }

        setupResizeOnBrowserResize();

        function setupResizeOnBrowserResize() {
            $window.on('resize', function resizeOnBrowserResize() {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    if ($('#casino-ingame').is(':visible')) {

                        resize();
                        scrollIntoView();
                    }
                }, RESIZE_DELAY);
            });
        }

        function getSplitHash(hash, index) {
            return hash.split(';')[index];
        }

        function getGameIdsFromHash(hash) {
            var gameIdPart = getSplitHash(hash, 0).toLowerCase();;
            if (gameIdPart.slice(2, 7) === 'game=' || gameIdPart.slice(2, 8) === 'group=') {
                var gameIds = gameIdPart.slice(2).split(',');
                return gameIds;
            }
            return [];
        }


        function resize() {
            scrollToGamesContainer();
            var gameIds = getGameIdsFromHash(location.hash);
            resizeAll(gameIds);

        }

        function saveGameSizeInLocalStorage($a) {
            if (localStorage) {
                var $span = $a.find('span');
                if ($span.hasClass(DEFAULT_SIZE_BUTTON)) {
                    localStorage.gameSize = DEFAULT_SIZE_BUTTON;
                }
                if ($span.hasClass(EXPANDED_SIZE_BUTTON)) {
                    localStorage.gameSize = EXPANDED_SIZE_BUTTON;
                }
            }
        }

        function scrollToGamesContainer() {
            var contentOffset = $('#casino-ingame').find('.content-wrapper').offset();
            var contentTop = 0;
            if (contentOffset && contentOffset.top) {
                contentTop = contentOffset.top;
            }

            $('html,body').stop(true).animate({scrollTop: contentTop});
        }

        var HARD_CODED_FREE_SPACE = 140;

        function resizeGameForLowCriticalResolutions(gameWidth) {

            var windowWidth = $(window).width();
            if (windowWidth - gameWidth >= HARD_CODED_FREE_SPACE) {
                return gameWidth;
            } else {

                return windowWidth - HARD_CODED_FREE_SPACE;
            }
        }

        function resizeAll(gameIds) {
            var gameMaxWidth = calculateGameMaxWidth();
            var gameMaxHeight = calculateGameMaxHeight();

            if (ingameFunctionalities.isNormalButtonChecked()) {
                gameMaxWidth = adjustWidthForNormalSize(gameMaxWidth, gameMaxHeight);
                gameMaxHeight = adjustHeightForNormalSize(gameMaxHeight);
            }

            var widestGameWidth = Number.MIN_VALUE;
            var lowestGameHeight = Number.MAX_VALUE;

            $.each(gameIds, function calculateGameHeight(_, id) {
                var ratio = getAspectRatioForGameId(id);

                var gameHeight = adjustHeightForRatio(gameMaxWidth, gameMaxHeight, ratio);
                lowestGameHeight = Math.min(gameHeight, lowestGameHeight);
            });

            var gameWidths = $.map(gameIds, function calculateGameWidth(id) {
                var ratio = getAspectRatioForGameId(id);
                var gameWidth = adjustWidthForRatio(gameMaxWidth, lowestGameHeight, ratio);
                widestGameWidth = Math.max(gameWidth, widestGameWidth);
                return gameWidth;
            });

            var gameContainerWidth = Math.max(widestGameWidth, lowestGameHeight);
            var $gameHolders = $('#casino-ingame').find('.game-holder');

            $.each(gameIds, function (i) {
                var $gh = $gameHolders.eq(i);

                var gameWidth = adjustForZoom(gameWidths[i]);
                var gameHeight = adjustForZoom(lowestGameHeight);

                //recalculate width and height for low screen
                if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
                    gameWidth = resizeGameForLowCriticalResolutions(gameWidth);
                    gameHeight = Math.round(gameWidth / getAspectRatioForGameId(gameIds[0]));
                }
                resizeGameFrame($gh, gameWidth, gameHeight);
                saveGameSize($gh, gameWidth, gameHeight);
            });

            gameContainerWidth = adjustForZoom(gameContainerWidth);
            gameContainerWidth = resizeGameForLowCriticalResolutions(gameContainerWidth);
            if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {

                $('.game-wrapper').width(gameContainerWidth + 2 * BOTH_SIDE_MARGINS_WIDTH);
            } else {
                $('.game-wrapper').width(gameContainerWidth * 2 + 3 * BOTH_SIDE_MARGINS_WIDTH);
            }

            activityFeed.resizeFeedAndDepositBasedOnGameRatioAndScreenResolution();
        }

        function calculateGameMaxWidth() {
            var absoluteMaxWidth;

            if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
                absoluteMaxWidth = $window.width();
            } else {
                absoluteMaxWidth = Math.floor($window.width() / 2) - HARDCODED_GAME_MARGIN_PIXELS;
            }

            return absoluteMaxWidth - BOTH_SIDE_MARGINS_WIDTH;
        }

        function calculateGameMaxHeight() {
            var topMargin = 0;
            var bottomMargin = 0;
            var controlBarHeight = 0;
            var tournamentHeight = 0;

            var $casinoIngame = $('#casino-ingame');
            if (casinoInfo.isSmallScreen()) {
                if (ingameFunctionalities.isMaximizedButtonChecked()) {
                    bottomMargin = -10; // hack due to using sizes of elements in page, should be cleaned up (TODO)
                } else {
                    bottomMargin = $casinoIngame.find('.player-bar').outerHeight();
                }
            }
            else {
                if (ingameFunctionalities.isMaximizedButtonChecked()) {
                    topMargin = HARDCODED_GAME_MARGIN_PIXELS;
                } else {
                    controlBarHeight = TOP_BAR_HEIGHT + HARDCODED_GAME_MARGIN_PIXELS;
                    bottomMargin = $casinoIngame.find('.player-bar').outerHeight() + HARDCODED_GAME_MARGIN_PIXELS;
                    tournamentHeight = $casinoIngame.find('#ingame-tournament-bar:visible').outerHeight();
                }
            }

            var windowHeight = $window.height();

            var absoluteMaxHeight = windowHeight - topMargin - controlBarHeight - tournamentHeight - GAME_MARGIN_HEIGHT - bottomMargin;

            if (gameMode.getGameMode() === gameMode.MODE_FOUR_GAMES) {
                absoluteMaxHeight /= 2;
                if (ingameFunctionalities.isExpandedButtonChecked()) {
                    absoluteMaxHeight -= bottomMargin / 2;
                }
                if (ingameFunctionalities.isMaximizedButtonChecked()) {
                    absoluteMaxHeight -= TOP_BAR_HEIGHT / 2;
                }
            }

            return absoluteMaxHeight;
        }

        function getAspectRatioForGameId(gameIds) {
            if (gameIds.indexOf('group') === 0) {
                return  GROUP_ASPECT_RATIO;
            }
            var game = casino.getGame(gameIds);
            return game.ratio;
        }

        function adjustWidthForNormalSize(width, height) {
            if (casinoInfo.isSmallScreen()) {
                return width;
            }

            if (gameMode.getGameMode() === gameMode.MODE_ONE_GAME) {
                var aspectRatio = width / height;
                if(aspectRatio > GROUP_ASPECT_RATIO) {
                    var weightedMaxWidth = DEFAULT_MAX_WIDTH * aspectRatio / GROUP_ASPECT_RATIO;
                    return Math.min(weightedMaxWidth, width);
                }

                return Math.min(DEFAULT_MAX_WIDTH, width);
            }
            return width;
        }

        function adjustHeightForNormalSize(height) {
            if (casinoInfo.isSmallScreen()) {
                return height;
            }

            if (gameMode.getGameMode() === gameMode.MODE_FOUR_GAMES) {
                return Math.min(DEFAULT_MAX_HEIGHT / 2, height);
            } else {
                return Math.min(DEFAULT_MAX_HEIGHT, height);
            }
        }

        function adjustWidthForRatio(width, height, ratio) {
            if (width / ratio > height) {
                return Math.floor(height * ratio);
            }

            return width;
        }

        function adjustHeightForRatio(width, height, ratio) {
            if (width / ratio <= height) {
                return Math.floor(width / ratio);
            }
            return height;
        }

        function resizeGameFrame($gameHolder, width, height) {
            var $gameLoader = $gameHolder.find('.game').find('iframe,object');

			$gameHolder.find('*[id^="loaded-game"]').width(width).height(height);
            $gameLoader.width(width).height(height);

            var $background = $gameHolder.find('.background');
            $background.width(width).height(height);
            $background.find('img').css('width', width + 20);

            var $inner = $gameHolder.find('.game-group .inner');
            if ($inner.width() > width) {
                $inner.width(width);
            } else {
                $inner.css('width', '');
            }

            var $gameGroup = $gameHolder.find('.game-group');
            $gameGroup.css('margin-top', '');
            $inner.width('');

            var $buttons = $gameHolder.find('.game-group .buttons');
            $buttons.width('');

            var $a = $buttons.find('a');
            $a.width('');

            if ($buttons.width() > width) {
                $buttons.width(width);
                $a.width(width / 2 - BOTH_SIDE_MARGINS_WIDTH);
                $gameGroup.css('margin-top', '5%');
                $inner.width(width);
            }

        }

        function saveGameSize($gameHolder, width, height) {

            $gameHolder.find('.game').data({width: width, height: height});
        }

        function adjustForZoom(widthOrHeight) {
            var zoomRatio = detectZoom.zoom();
            return widthOrHeight / zoomRatio;
        }

        /**
         * @returns {number} top position after scrolling into view
         */
        function calculateScrollTopPosition() {
            var $casinoIngame = $('#casino-ingame');
            var $contentWrapper = $casinoIngame.find('.content-wrapper').first();

            var barTop = $contentWrapper.offset().top;
            var gameTopWithMargin = barTop + $contentWrapper.outerHeight();
            var gameTopWithoutMargin = $casinoIngame.find('.game-holder .inner').offset().top;

            if (casinoInfo.isSmallScreen()) {
                return gameTopWithoutMargin;
            }

            if (ingameFunctionalities.isMaximizedButtonChecked()) {
                return gameTopWithMargin;
            }

            return barTop;
        }

        function scrollIntoView(delay) {
            if (typeof delay === 'undefined') {
                delay = 0;
            }

            $(function scrollGameIntoView() {
                setTimeout(function () {
                    var scrollTop = calculateScrollTopPosition();
                    $('html,body').stop(true).animate({scrollTop: scrollTop}, 800);
                }, delay);
            });
        }

		function doLogout() {
			if($('#casino-ingame').length > 0) {
				scrollTo(0, calculateScrollTopPosition());
			}
		}

		$(session).on('logout', doLogout);

        return gameResize;
    }
);

